import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export function useMaxUpdateIntervalOptions() {
    return useQuery({
        queryKey: ['max-update-interval-options'],

        queryFn: () => sdClient.getMaxUpdateIntervalOptions({}),
    });
}
